import React from 'react';
import Modal from 'react-modal';
import { useForm } from "react-hook-form";
import emailjs from 'emailjs-com';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        height: '60%',
        width: '80%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        boxShadow: '2px 5px 15px lightgray'
    }
};

const inputStyle = {
    width: '50vw',
    borderRadius: '5px',
    marginTop: '15px'
}

Modal.setAppElement('#root');

const MessageForm = ({ modalIsOpen, closeModal }) => {
    const { register } = useForm();

    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('gmail', 'template_1i9wyob', e.target, 'user_HKK0KjMxx4zbe4xkA6B5G')
          .then((result) => {
              console.log(result.text);
              closeModal();
          }, (error) => {
              console.log(error.text);
          });
      }

    return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >

                <h2>Get in touch</h2>
                <form onSubmit={sendEmail}>
                    <input name="name" placeholder="Name" style={inputStyle} ref={register} /> <br />

                    <input name="email" placeholder="Email" style={inputStyle} ref={register} /> <br />

                    <textarea style={inputStyle} rows="4" cols="50" name="message" placeholder="Message" ref={register}></textarea> <br />

                    <input style={inputStyle} className="btn btn-dark ml-2 mt-3" type="submit" value="Send Message" />
                </form>
            </Modal>
        </div>
    );
};

export default MessageForm;